export const SignInEmailErrorCodeEnum = {
  InvalidEmail: 'auth/invalid-email',
  UserDisabled: 'auth/user-disabled',
  UserNotFound: 'auth/user-not-found',
  WrongPassword: 'auth/wrong-password',
  EmailAlreadyInUse: 'auth/account-exists-with-different-credential',
};